<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol><h5 class="my-2">User Management</h5> </CCol>
                            <CCol>
                                <CLink
                                    @click="$router.back()"
                                    class="float-right my-2"
                                    >Back to client management</CLink
                                >
                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody :style="{ position: 'relative', top: '-18px' }">
                        <CDataTable
                            :items="users"
                            :fields="fields"
                            :column-filter="false"
                            :itemsPerPageSelect="true"
                            hover
                            sorter
                            pagination
                            @filtered-items-change="setCurrentItems"
                        >
                            <template #account_status="{ item }">
                                <td
                                    class="font-weight-bold"
                                    :style="`color: ${getColorOnStatus(
                                        getAccountStatus(item)
                                    )}`"
                                >
                                    {{ getAccountStatus(item) }}
                                </td>
                            </template>
                            <template #client_name="{ item }">
                                <td>{{ item.client.name }}</td>
                            </template>
                            <template #role_name="{ item }">
                                <td>
                                    <CBadge
                                        color="primary"
                                        class="font-weight-bold"
                                        shape="pill"
                                        style="font-size: 90%"
                                    >
                                        {{ getFullRoleName(item.role.name) }}
                                    </CBadge>
                                </td>
                            </template>
                            <template #action="{}"> </template>
                            <template #group_action="{ item }">
                                <td>
                                    <div style="width: max-content">
                                        <CButton
                                            style="cursor: pointer"
                                            @click="
                                                addAdminGroupClickHandler(item)
                                            "
                                            color="primary"
                                        >
                                            {{
                                                item.role.name == "group_admin"
                                                    ? "Edit Group Admin"
                                                    : "Make Group Admin"
                                            }}
                                        </CButton>
                                    </div>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>

            <CElementCover v-if="spinner" :opacity="0.8" />

            <CModal
                title="Add Group Admin"
                :show.sync="groupModal"
                :centered="true"
                :fade="true"
                class="disable-footer"
            >
                <div>
                    <label><b>User:</b></label>
                    {{ editingItem.name }}
                </div>

                <div class="mt-2">
                    <label><b>Clients*:</b></label>
                    <div
                        class="px-2 py-2 mt-2"
                        style="
                            max-height: 200px;
                            overflow: auto;
                            border-style: solid;
                        "
                    >
                        <CInputCheckbox
                            v-for="client in clients"
                            v-bind:key="client.id"
                            :label="client.name"
                            :value="client.id"
                            :checked="isChecked(client.id)"
                            @update:checked="handleCheckBoxUpdate(client.id)"
                        />
                    </div>
                </div>
                <div class="inactive-modal-response mt-4 float-right">
                    <CButton
                        type="cancel"
                        color="secondary"
                        class="m-1"
                        @click="handleCancel()"
                    >
                        Cancel
                    </CButton>
                    <CButton type="submit" color="primary" class="m-1"  @click="handleSubmit(editingItem)">
                        Submit
                    </CButton>
                </div>
            </CModal>
        </CRow>
    </div>
</template>

<script>
import { getSelectedClients, storeData } from "../../store";
import queries from "./queries";

const fields = [
    { key: "name", label: "Full Name" },
    { key: "email" },
    { key: "client_name", label: "Client / Hospital Name" },
    { key: "role_name", label: "Role" },
    { key: "account_status", label: "Account Status" },
    { key: "action", label: "", _classes: "remove-sort-arrow" },
    { key: "group_action", label: "" },
];

export default {
    props: {
        client_id: String,
    },
    data() {
        return {
            currentItems: [],
            users: [],
            currentUser: {},
            fields,
            eachUserModal: false,
            userApprovalComment: "",
            groupModal: false,
            editingItem: {},
            clients: [],
            groups:[],
            selectedIds: [],
            spinner: false
        };
    },
    methods: {
        // Based on status
        isActive: (user) =>
            !user.verification_pending &&
            !user.is_rejected &&
            !user.account_disabled,

        isDisabled: (user) => user.account_disabled,
        isVerificationPending: (user) => user.verification_pending,
        isRejected: (user) => user.is_rejected,

        // Based on role
        isSysAdmin: (user) => user.role.name === "sys_admin",
        isGroupAdmin: (user) => user.role.name === "group_admin",
        isClientUser: (user) => user.role.name === "client_user",
        isClientAdmin: (user) => user.role.name === "client_admin",

        // tempResultData = this.rawData.filter(row => {
        // 		if (checkedClientsValues.length === 0 || checkedClientsValues.indexOf(row.client_name) > -1 &&
        // 			checkedGroupsValues.length === 0 || checkedGroupsValues.indexOf(row.opportunity_group) > -1) {
        // 			return true;
        // 		}
        // 		return false;
        // 	});

        handleCheckBoxUpdate(selectedId) {
            var idx = this.selectedIds.indexOf(selectedId);
            if (idx > -1) {
                this.selectedIds.splice(idx, 1);
            } else {
                this.selectedIds.push(selectedId);
            }
        },
        handleCancel(){
            this.groupModal = false;
            this.selectedIds = [];
        },

        async handleSubmit(item){
            this.spinner = true;

            try {
                const response = await this.$apollo.mutate({
                mutation: queries.ADD_GROUP_ASSIGNMENT,
                variables: {
                    users_id: item.id,
                    clients: this.selectedIds,
                },
                });
            } catch (error) {
                console.error('Mutation error:', error);
            }
            this.getClientData();
            this.$apollo.queries.userData.refetch();


            this.selectedIds = [];
            this.spinner = false;
            this.groupModal = false;
        },


        isChecked(Id) {
            var idx = this.selectedIds.indexOf(Id);
            if (idx > -1) {
                return true
            } else {
               return false
            }

        },

        async addAdminGroupClickHandler(item) {
            this.selectedIds = [];
            if(item.role.name == 'group_admin'){
            try {
                const response = await this.$apollo.mutate({
                mutation: queries.GET_CHECKED_CLIENTS,
                variables: {
                    users_id: item.id,
                },
                });
                this.groups  = response.data.spendmd_db_get_checked_clients ;
            } catch (error) {
                console.error('Mutation error:', error);
            }

            for(let i=0; i < this.groups.length; i++){
                if(this.groups[i].is_grouped == true){
                    this.selectedIds.push(this.groups[i].client_id)
                }
            }
            }
                else{
                    this.selectedIds.push(item.client_id);
                }
            this.editingItem = item;
            this.groupModal = true;
        },

        getFullRoleName: (roleName) => {
            if (roleName === "client_admin") return "Client Admin";
            else if (roleName === "client_user") return "Client User";
            else if (roleName === "sys_admin") return "System Admin";
            else if (roleName === "group_admin") return "Group Admin";
            else return "";
        },
        getAccountStatus(item) {
            if (this.isActive(item)) return "Active";
            else if (this.isDisabled(item)) return "Disabled";
            else if (this.isRejected(item)) return "Rejected";
            else if (this.isVerificationPending(item)) return "Pending";
            else return "";
        },

        getColorOnStatus(status) {
            if (status === "Active") return "#0bbd40";
            else if (status === "Disabled") return "#ff6700";
            else if (status === "Pending") return "#b6bccb";
            else return "#f11a1a";
        },

        setCurrentItems(val) {
            this.currentItems = val;
        },
        approveUser() {
            this.currentUser.acct_status = "Approved";
            this.updateUser(this.currentUser);
            this.eachUserModal = false;
        },
        rejectUser() {
            this.currentUser.acct_status = "Rejected";
            this.updateUser(this.currentUser);
            this.eachUserModal = false;
        },
        updateUser(query, data) {
            this.$apollo
                .mutate({
                    mutation: UPDATE_USER_AUTHENTICATION,
                    variables: {
                        name: data.name,
                        acct_status: data.acct_status,
                        comment: this.userApprovalComment
                            ? this.userApprovalComment
                            : null,
                    },
                })
                .then((res) => {
                    const result = res?.data?.update_spendmd_db_user?.returning;
                    if (
                        result.length > 0 &&
                        result[0].acct_status != "Pending"
                    ) {
                        for (const [
                            index,
                            el,
                        ] of this.userAuthenticationList.entries()) {
                            if (el.id == result[0].id) {
                                this.userAuthenticationList.splice(index, 1);
                            }
                        }
                        storeData.userAuthenticationList =
                            this.userAuthenticationList;
                        storeData.count = this.userAuthenticationList.length;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getClientData() {
            await this.$apollo
                .mutate({
                    mutation: queries.GET_CLIENTS_LIST,
                    variables: {},
                })
                .then((res) => {
                    this.clients = res.data.spendmd_db_clients;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    beforeMount() {
        this.getClientData();
        this.$apollo.queries.userData.refetch();
    },
    apollo: {
        userData: {
            query: queries.GET_USERS,
            update: (data) => data,
            variables() {
                return {
                    client_id: this?.$route?.query?.client_id,
                };
            },
            result({ data }) {
                this.users = data.spendmd_db_users;
            },
        },
    },
};
</script>

<style scoped>
textarea.form-control {
    height: 112px !important;
}
</style>
